import React from 'react';
import { GrSend } from '@react-icons/all-files/gr/GrSend';

const SendBtn = () => {

    return (
        <GrSend className="green-btn-plus send"/>
    )
}

export default SendBtn